function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { createTimezonedDate, getLocaleDateFormat, getLocaleDateTimeFormat } from './dateUtils';
const DatePicker = _ref => {
  let {
    selected,
    onChange,
    className,
    disabled,
    dateFormat,
    showTime,
    shouldFormatDate = true,
    allowNullDate,
    ...rest
  } = _ref;
  const dataTestId = rest['data-testid'];
  const {
    'data-testid': _,
    ...restWithoutTestId
  } = rest;
  if (showTime && !dateFormat) {
    dateFormat = getLocaleDateTimeFormat();
  } else if (!dateFormat) {
    dateFormat = getLocaleDateFormat();
  }
  const handleDateChange = (date, name) => {
    let result = null;
    let formattedDate;
    let utcDate;
    if (date) {
      utcDate = createTimezonedDate(date);
      formattedDate = `${utcDate.getDate()}/${utcDate.getMonth() + 1}/${utcDate.getFullYear()}`;
    } else if (!date && allowNullDate) {
      utcDate = null;
      formattedDate = null;
    }
    if (!shouldFormatDate && !showTime) {
      date.setHours(0, 0, 0, 0);
    }
    result = shouldFormatDate ? formattedDate : utcDate;
    onChange(result);
  };
  const datePicker = /*#__PURE__*/React.createElement(ReactDatePicker, _extends({}, restWithoutTestId, {
    disabled: disabled,
    className: className || 'custom-datepicker-input form-control',
    selected: createTimezonedDate(selected),
    onChange: date => handleDateChange(date),
    dateFormat: dateFormat,
    showTime: showTime,
    showYearDropdown: true,
    timeFormat: "HH:mm"
  }));
  if (dataTestId) {
    return /*#__PURE__*/React.createElement("span", {
      "data-testid": dataTestId
    }, datePicker);
  }
  return datePicker;
};
export default DatePicker;